export default __webpack_public_path__ + "static/media/cyan-01-b.ef3586ff.png";